import { render } from "./FormularioAcademyFidelizacion.vue?vue&type=template&id=346f4662&scoped=true&ts=true"
import script from "./FormularioAcademyFidelizacion.vue?vue&type=script&lang=ts"
export * from "./FormularioAcademyFidelizacion.vue?vue&type=script&lang=ts"

import "./FormularioAcademyFidelizacion.vue?vue&type=style&index=0&id=346f4662&scoped=true&lang=css"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-346f4662"]])

export default __exports__